import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = () => {

	const location = useLocation();

	// 페이지 이동시 Scroll 위치 상단으로 초기화
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [location])
}

export default ScrollTop

  